module.exports = __webpack_public_path__ + "static/img/bg-value.129a2bbe.jpg";